import React, { useEffect, useState } from "react";
import BannerCarousel from "../components/BannerCarousel";
import Collection from "../components/Collection";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Medias from "../components/Medias";
import News from "../components/News";
import Organize from "../components/Organize";
import Services from "../components/Services";
import Shortcuts from "../components/Shortcuts";
import SiteMap from "../components/SiteMap";
import axios from "axios";

const Home = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [banners, setBanners] = useState([]);
    const [autoplayEnabled, setAutoplayEnabled] = useState(true);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // for smoothly scrolling
        });

        const loadBanners = async () => {
            const resp = await axios.get(
                `https://mw2c0cho61.execute-api.sa-east-1.amazonaws.com/production/banners?limit=4`,
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    crossDomain: true,
                }
            );

            setBanners(resp.data);
        };

        loadBanners();
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Sindsep - Sindicato dos Servidores Municipais de São Paulo</h1>
                <h2 className="sr-only">Banners em destaque</h2>
                <div style={{ position: 'relative' }}>
                    <BannerCarousel
                        items={banners}
                        autoplayEnabled={autoplayEnabled}
                        autoplayInterval={5000}
                        isMobile={isMobile}
                    />
                    <button
                        onClick={() => setAutoplayEnabled(!autoplayEnabled)}
                        style={{
                            position: 'absolute',
                            bottom: 10,
                            right: 10,
                            zIndex: 10,
                            backgroundColor: 'rgba(0,0,0,0.6)',
                            color: '#FFFFFF',
                            border: '2px solid #FFFFFF',
                            borderRadius: 4,
                            padding: '6px 12px',
                            cursor: 'pointer',
                            fontFamily: 'Raleway',
                            fontWeight: '600',
                            fontSize: '14px',
                        }}
                    >
                        {autoplayEnabled ? "⏸ Pausar rotação dos banners" : "▶ Reproduzir rotação dos banners"}
                    </button>
                </div>
                <Shortcuts isMobile={isMobile} />
                <Services />
                <Organize isMobile={isMobile} />
                <News />
                <Medias isMobile={isMobile} />
                <Collection />
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
};

export default Home;
